export interface CommunityPost {
  id: string;
  author: string;
  avatar: string;
  time: string;
  topic: string;
  content: string;
  likes: number;
  comments: number;
}

export const hotTopics = ['全部', '影视讨论', '短视频安利', '直播闲聊', '片单分享', '观后感'];

export const communityPosts: CommunityPost[] = [
  {
    id: 'p1',
    author: '夜航星',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20calm%20stargazer%20with%20warm%20peach%20and%20beige%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-1&orientation=squarish',
    time: '12 分钟前',
    topic: '影视讨论',
    content: '《星海旅途》的结尾留白太妙了，二刷才发现开头那个信号其实早就埋了伏笔。有没有人和我一样看到最后泪目？',
    likes: 328,
    comments: 46,
  },
  {
    id: 'p2',
    author: '慢煮生活',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20friendly%20cook%20with%20a%20chef%20hat%2C%20warm%20peach%20and%20amber%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-2&orientation=squarish',
    time: '38 分钟前',
    topic: '短视频安利',
    content: '新一期《山野食光》拍到了秋天的第一顿板栗焖饭，光是看画面就饿了。这个系列真的越做越治愈。',
    likes: 512,
    comments: 73,
  },
  {
    id: 'p3',
    author: '迷雾观众',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20thoughtful%20detective%20with%20a%20magnifier%2C%20peach%20and%20grey%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-3&orientation=squarish',
    time: '1 小时前',
    topic: '影视讨论',
    content: '《迷雾谜城》第 9 集那个时间线我终于理清了！建议二刷的时候把三条线分开记笔记，体验完全不同。',
    likes: 286,
    comments: 58,
  },
  {
    id: 'p4',
    author: '甜梦小耳朵',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20girl%20with%20headphones%2C%20warm%20peach%20and%20rose%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-4&orientation=squarish',
    time: '2 小时前',
    topic: '直播闲聊',
    content: '今晚甜梦电台的歌单好绝，点了一首老歌居然真的放到了，主播还会念弹幕故事，睡前必听。',
    likes: 194,
    comments: 31,
  },
  {
    id: 'p5',
    author: '追风的人',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20cyclist%20with%20helmet%2C%20warm%20peach%20and%20green%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-5&orientation=squarish',
    time: '3 小时前',
    topic: '片单分享',
    content: '整理了一份「通勤十分钟」短视频片单，《晨跑日记》和《复古时光机》都很上头，欢迎补充。',
    likes: 421,
    comments: 87,
  },
  {
    id: 'p6',
    author: '像素工坊',
    avatar: 'https://readdy.ai/api/search-image?query=minimal%20flat%20illustration%20avatar%20of%20a%20creative%20editor%20with%20a%20camera%2C%20warm%20peach%20and%20amber%20palette%2C%20simple%20clean%20background&width=120&height=120&seq=mvita-avatar-6&orientation=squarish',
    time: '5 小时前',
    topic: '观后感',
    content: '《城市光影录》的美术真的值得单独拿出来讲，每一帧截下来都能当壁纸，氛围感拉满。',
    likes: 267,
    comments: 39,
  },
];